import { useEffect, useState } from "react";
import PortfolioService from "../../../../../services/PortfolioService";
import { Dropdown, IDropdownOption, Spinner } from "@fluentui/react";
import { TActivePlan } from "../../types/TActivePlan";
import { dropdownStylesSingle } from "../../Styles/DropDownStyles";
import FinametrixService from "../../../../../services/FinametrixService";
import { TLevel2PositionRaw, TReporting } from "../../../Summary/types/PortfolioTypes";
import { TPrincipalPositions, TWalletData, TWalletProductInfo } from "../../types/PrincipalPositionTypes";
import TableDistribution from "../../Components/TableDistribution/TableDistribution";
import { FormatTableDistribution } from "../../Util/FormatTableDistribution";
import { FormatPieDistributionData } from "../../Util/FormatPieDistributionData";
import PieHighStockFileCustom from "../../Components/PieHighStock/PieHighStockFileCustom";

;

const BASE_CLASS = 'distribucion';

type TDistribucionProps = {
    activePlan: TActivePlan;
    options: IDropdownOption[];
}

const Distribucion = ({ activePlan, options }: TDistribucionProps) => {
    const [isloadingTable, setIsloadingTable] = useState<boolean>(true);
    const [principalPositions, setPrincipalPositions ] = useState<TWalletData>({} as TWalletData);
    const [productInfo, setProductInfo] = useState<TWalletProductInfo[]>([]);
    const [data, setData] = useState<TPrincipalPositions[]>([]);

    const getPrincipalPositions = async () => {
        const isinList = productInfo.map(product => product.isin);

        await PortfolioService.getPrincipalPositions(isinList)
            .then(response => {
                const tableDistributionData = FormatTableDistribution({
                    walletRelationsInfo: productInfo,
                    principalPositionsList: response
                });
                setPrincipalPositions(tableDistributionData);
                setData(response);
                setIsloadingTable(false);
        });
    };
    
    useEffect(() => {
        getPrincipalPositions();
    }, [productInfo]);

    const finametrixReporting = async (option?: IDropdownOption) => {
        const finametrixPortfolio = await FinametrixService.getPortfolio(option?.id || activePlan.portfolio.finametrixId).catch();
        const fromDate = finametrixPortfolio?.creationDate?.substring(0, 10).replace(/-/g, "");
        const date_to = new Date();
        date_to.setDate(date_to.getDate() - 1);
        const date_to_text = `${date_to.getFullYear()}${String(date_to.getMonth() + 1).padStart(2, '0')}${String(date_to.getDate()).padStart(2, '0')}`;
        const nestPortfolioResult: TReporting = await FinametrixService.getReporting(option?.id || activePlan.portfolio.finametrixId, fromDate, date_to_text);

        
        const productInfoList: TWalletProductInfo[] = nestPortfolioResult.positions.positionsTo.positions
            .filter((pos: TLevel2PositionRaw) => pos.isin !== null)
            .map((position: TLevel2PositionRaw) => {
                return {
                    isin: position.isin,
                    name: position.productName,
                    weight: position.weight 
                };
            }).sort((a, b) => b.weight - a.weight); // Orden descendente por weight

        setProductInfo(productInfoList);
    };

    useEffect(() => {
        finametrixReporting();
    }, [])

    const circleCountryData = FormatPieDistributionData({ principalPositions: data, walletRelationsInfo: productInfo, fundType: "Country" })
    const circleSectorData = FormatPieDistributionData({ principalPositions: data, walletRelationsInfo: productInfo, fundType: "Sector" })

    const onUpdateSelectionWallets = async (event: React.FormEvent<HTMLDivElement>, option: IDropdownOption | undefined): Promise<void> => {
        if (option?.key) {
            finametrixReporting(option);
        };
        setIsloadingTable(true);
    };

    return (
        <div className={BASE_CLASS}>
            
            <div className={`${BASE_CLASS}__dropdown__container`}>
                <Dropdown placeholder={activePlan.name}
                    className={`${BASE_CLASS}__dropdown`}
                    options={options as IDropdownOption[]}
                    defaultSelectedKeys={[activePlan.finametrixContract]}
                    onChange={onUpdateSelectionWallets}
                    styles={dropdownStylesSingle}
                />
            </div>
            <div className={`${BASE_CLASS}__data__container`}>
                <div className={`${BASE_CLASS}__mainTable`}>
                    <div className={`${BASE_CLASS}__mainTable__distribucionActivos`}>
                        <h3>Distribución de activos</h3>
                        {isloadingTable
                            ? <Spinner size={3} style={{ padding: "1em" }} />
                            : <TableDistribution walletData={principalPositions} />
                        }
                    </div>
                </div>
                <div className={`${BASE_CLASS}__leftColumn`}>
                    <div className={`${BASE_CLASS}__pieChart`}>
                        <h3>Distribución Geográfica</h3>
                        {isloadingTable 
                            ? <Spinner size={3} style={{ padding: "1em" }} />
                            : <PieHighStockFileCustom chartSerie={circleCountryData} showSubcategories={false} />
                        }
                    </div>
                    <div className={`${BASE_CLASS}__pieChart`}>
                        <h3>Distribución Sectorial</h3>
                        {isloadingTable 
                            ? <Spinner size={3} style={{ padding: "1em" }} />
                            : <PieHighStockFileCustom chartSerie={circleSectorData} showSubcategories={false} />
                        
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Distribucion;